import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { CmsService } from '@spartacus/core';
import { filter, map, take } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { CustomVerticalFourSelectionData } from './custom-vertical-four-selection.model';
import {
  CustomCmsEventService
} from "src/app/spartacus/features/tracking/custom-events/checkout/cms/custom-cms-event.service";

@Component({
  selector: 'app-custom-vertical-four-selection',
  templateUrl: './custom-vertical-four-selection.component.html',
  styleUrls: ['./custom-vertical-four-selection.component.scss'],
  standalone: false
})
export class CustomVerticalFourSelectionComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    protected componentData: CmsComponentData<CustomVerticalFourSelectionData>,
    private cmsService: CmsService,
    protected breakpointService: BreakpointService,
    protected cd: ChangeDetectorRef,
    private customCmsEventService: CustomCmsEventService,
  ) {
  }

  protected subscriptions: Subscription = new Subscription();
  animation = 'swipe';
  data$ = this.componentData.data$.pipe(map(component => component));
  items$: Observable<any> = this.componentData.data$.pipe(
    filter(data => Boolean(data.items)),
    map(data =>
      data.items.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
        map(tab => tab),
      )),
    ));

  ngOnInit(): void {
  }

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.sm);
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.items$.pipe(take(1)).subscribe(
        items => {
          const bannerList = this.customCmsEventService.getComponentList(items);
          this.customCmsEventService.dispatchViewPromotionEvent(bannerList);
        }
      )
    )
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
